export const TAP2CASH_APP_URL = "https://play.google.com/store/apps/details?id=com.tap2cash.mobile";

export function unavailablePincode(pincode, message, downloadAppUrl = TAP2CASH_APP_URL) {
  return { pincode: String(pincode || ""), message: message || "Pickup is currently unavailable in this area.", downloadAppUrl };
}

export function pincodeLookupRejection(error, pincode) {
  const response = error?.response?.data || {};
  if (error?.response?.status !== 404 && response.error_code !== "CAMPAIGN_PINCODE_NOT_COVERED") {
    return null;
  }
  return unavailablePincode(pincode, response.message, response.errors?.download_app_url || TAP2CASH_APP_URL);
}

export function validPincodeLookup(response, pincode) {
  const data = response?.data ?? response;
  return Boolean(data?.city?.id && data?.areas?.length && String(data.pincode) === String(pincode));
}
